export default "__VITE_ASSET__G7mqaSjm__"